<button class="close-button" (click)="onNoClick()">
  <span aria-hidden="true">&times;</span>
</button>
<h1 mat-dialog-title class="pop-up-title">Confirm Remove</h1>
<div mat-dialog-content>

  <p>
    This item will be removed from the order. Click confirm to proceed.
  </p>


</div>
<div mat-dialog-actions style="text-align: center;">
  <button mat-button class="button button-red button-mid continue" style="line-height: unset" (click)="onNoClick()">Cancel</button>
  <button mat-button class="button button-red button-mid continue" style="line-height: unset" (click)="confirmDelete()">Confirm</button>
</div>

